import script from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeLayout.vue?vue&type=script&setup=true&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=71adad16&lang=less"

const __exports__ = script;

export default __exports__